import React from 'react';
import styles from './PaymentInvoices.module.css';

const DownloadModal = ({ isOpen, invoice, onClose }) => {
  if (!isOpen || !invoice) return null;

  const options = [
    {
      label: '📄 Download PDF',
      url: invoice.pdfUrl,
      available: !!invoice.pdfUrl,
    },
    {
      label: '📄 Download Admin PDF',
      url: invoice.adminPdfUrl,
      available: !!invoice.adminPdfUrl,
    },
    {
      label: '📊 Download CSV',
      url: invoice.csvUrl,
      available: !!invoice.csvUrl,
    },
    {
      label: '📊 Download Admin CSV',
      url: invoice.adminCsvUrl,
      available: !!invoice.adminCsvUrl,
    },
  ];

  return (
    <div
      className={styles.modalBg}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.modalBox} style={{ width: 360 }}>
        <div className={styles.modalTitle}>Download Invoice</div>
        <div className={styles.modalSub}>
          <span style={{ fontFamily: 'monospace', color: 'var(--or)' }}>
            {invoice.invoiceNumber}
          </span>
          {' · '}
          {invoice.company?.name ?? ''}
        </div>

        <div
          className={styles.modalActions}
          style={{ flexDirection: 'column', gap: 8, marginTop: 4 }}
        >
          {options.map(({ label, url, available }) => (
            <div
              key={label}
              style={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <button
                className={`${styles.btn} ${
                  available ? styles.btnSecondary : ''
                }`}
                style={{
                  justifyContent: 'center',
                  padding: 11,
                  opacity: available ? 1 : 0.45,
                  cursor: available ? 'pointer' : 'not-allowed',
                }}
                disabled={!available}
                onClick={() => {
                  window.open(url, '_blank');
                  onClose();
                }}
              >
                {label}
              </button>
              {!available && (
                <span
                  style={{ fontSize: 11, color: '#d9534f', paddingLeft: 2 }}
                >
                  URL not available
                </span>
              )}
            </div>
          ))}
          <button
            className={`${styles.btn} ${styles.btnSecondary}`}
            style={{ justifyContent: 'center', padding: 11 }}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
